import { GENERAL_GRAPH, GRAPH_GRAPH_RESULTS, } from "./types";
const initialState = {
    sliderOptions: null,
    openingBalance: null,
    strategyIndex: null,
    expense_home: null,
    socialSecurity: [],
    graph: {
        assets: [],
        gap: [],
        future: [],
        results: {
            retirementAssests: 0,
            retirementGap: 0,
            futureExpenses: 0,
            retireReturns: 0,
        },
        flag: null,
    },
    editVisible: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_GRAPH:
            const updated = {
                ...state,
                ...action.payload,
            };
            return updated;
        case GRAPH_GRAPH_RESULTS:
            return {
                ...state,
                graph: {
                    ...state.graph,
                    ...action.payload.graph,
                    results: {
                        ...state.graph.results,
                        ...action.payload.results,
                    },
                },
            };
        default:
            return state;
    }
};
